
import { NetworkError } from "./errors/NetworkError";
import { CorsError } from "./errors/CorsError";
import { GeneralError } from "./errors/GeneralError";

interface ErrorDisplayProps {
  errorMessage: string | null;
  isOnline: boolean;
  onRetry?: () => void;
}

export function ErrorDisplay({ 
  errorMessage, 
  isOnline, 
  onRetry 
}: ErrorDisplayProps) {
  if (!errorMessage && isOnline) return null;

  if (!isOnline) {
    return <NetworkError onRetry={onRetry} />;
  }

  const hasCorsError = errorMessage?.includes('CORS') || errorMessage?.includes('data.map');

  return (
    <>
      {!hasCorsError && (
        <GeneralError 
          message={errorMessage || ''} 
          hasCorsError={false} 
          onRetry={onRetry} 
        />
      )}
      {hasCorsError && (
        <CorsError 
          onRetry={onRetry}
          errorMessage={errorMessage || ''}
        />
      )}
    </>
  );
}
